<template>
    <div class="app-index">
        <div class="container d-flex justify-content-center">
            <div class="form-material mt-5">
                <div>
                    <img src="@/extra/custom/img/logo-full.png" width="250">
                </div>
                <div class="form-group form-default" v-if="!msg">
                    <input type="text" class="form-control" :class="{'fill': username}" id="username" name="username" v-model="username">
                        <span class="form-bar">
                        </span>
                        <label class="float-label">{{tr('User')}}</label>
                    </input>
                </div>
                <div class="form-group form-default">
                    <input type="password" class="form-control" :class="{'fill': password}" id="password" name="password" v-model="password">
                        <span class="form-bar">
                        </span>
                        <label class="float-label">{{tr('Password')}}</label>
                    </input>
                </div>
                <div class="d-flex justify-content-center">
                    <button id="submit" @click="login" class="btn btn-primary w-100" :disabled="processing">
                        <span v-if="!processing">{{tr('Sign in')}}</span>
                        <img class="processing-gif" src="@/img/loading.gif" v-else>
                    </button>
                </div>
                <div class="form-group d-flex justify-content-center">
                    <label v-if="error" class="alert alert-danger" role="alert">
                        {{ tr(error) }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'login',
    data () {
        return {
            processing: false,
            username: null,
            password: null,
            error: null,
            msg: null,
        }
    },
    mounted () {
        this.$store.commit("setUser", null);
    },
    methods: {
        handleError (response) {
            this.error = response.err;
        },
        async login () {
            this.error = null;
            var data = new FormData();
            data.append('username', this.username);
            data.append('password', this.password);
            let res = await api.post('/login', data, {}, this.handleError)
            if (res) {
                this.$store.commit('setUser', res);
                api.getCurrentUser()
                if (res.ChangePassword) {
                    this.$router.push('/change-password')
                } else {
                    this.$router.push('/')
                }
            }
        },
    },
}
</script>

